import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ReportsService {
    constructor(
        private apiService: ApiService,
        private router: Router
    ) {
        
    }

    getReportDetails(reportName:string, params?: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`reports/report-data/${reportName}`, params);
    }

    getReportList(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('reports/report-list', params);
    }

    getReportFilters(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('reports/report-filters', params);
    }

    downloadReport(reportName:string, params?: any) {
        const httpOptions = {
            responseType: "blob",
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.apiService.post<any>(`reports/report-export/${reportName}`, params, httpOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/reports.service.ts